import './header';
import './site';

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded and parsed');
});
